import { Directive, OnDestroy, inject, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';


@Directive({
  selector: 'form',
  standalone: true,
})
export class FormDirective implements OnDestroy {

  private readonly ngForm = inject(NgForm, { self: true });
  private formSubscription: Subscription;

  @Output() formValueChange = new EventEmitter<any>();
  @Output() formValid = new EventEmitter<boolean>();
  @Output() formDirty = new EventEmitter<boolean>();

  constructor() {

    this.formSubscription = this.ngForm.form.valueChanges.subscribe(() => {

      if (this.ngForm.dirty) {
          this.formDirty.emit(this.ngForm.dirty);
          this.formValid.emit(this.ngForm.valid ?? false);
          this.formValueChange.emit(this.ngForm.form.value);
        }

      });
  }

  ngOnDestroy(): void {
    // Unsubscribe when the directive is destroyed
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

}
